const ApiAttributesKeys = {
  chapterIdKey: 'chapterId',
  readingIdKey: 'reading_id',
  chapterNameKay: 'chapterName',
  totalReadingKey: 'TotalReading',
  freeQuestionsCountKey: 'TotalFreeQuestions',
  premiumQuestionsCountKey: 'TotalQuestions',
  tableKey: 'frm_note',
  tableChapterKey: 'chapter_id',
  //* notes key's
  totalNotesKey: 'TotalNotes',
};
module.exports = ApiAttributesKeys;



// WEBPACK FOOTER //
// ./src/views/FRM-V2/Notes/ApiAttributesKays.js